import { ReactNode } from 'react';

interface TabData {
  name: string;
  label: string;
  itemsCount?: number;
  stat?: string;
  isSelected: boolean;
  onClick?: () => void;
}

export enum TabVariantEnum {
  Grey = 'grey',
  Blue = 'blue'
}

export interface SearchTabsProps {
  currentTabId?: number;
  switchTab?: React.Dispatch<React.SetStateAction<number>>;
  children?: ReactNode;
  titles?: TabData[];
  disabled: boolean;
  variant?: TabVariantEnum;
  height?: number;
}
